import Keycloak from 'keycloak-js';
import { AUTH_CLIENT_ID, AUTH_REALM, AUTH_URL } from '@/config';

const keycloak = new Keycloak({
    url: AUTH_URL,
    realm: AUTH_REALM,
    clientId: AUTH_CLIENT_ID,
});

let refreshTimer: number | null = null;

export function scheduleKeycloakTokenRefresh(keycloak: Keycloak.KeycloakInstance) {
    const exp = keycloak.tokenParsed?.exp;

    if (!exp) return;

    const now = Math.floor(Date.now() / 1000);

    const secondsBeforeRefresh = 30;

    const refreshInMs = Math.max((exp - now - secondsBeforeRefresh) * 1000, 1000);

    if (refreshTimer) window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(async () => {
        try {
            await keycloak.updateToken(60);

            scheduleKeycloakTokenRefresh(keycloak);
        } catch (e) {
            keycloak.login();
        }
    }, refreshInMs);
}

export function useKeycloak() {
    return keycloak;
}
